<script setup lang="ts">
defineProps<{
  error: {
    statusCode: number
    statusMessage: string
  }

}>()
</script>

<template>
  <div font-inter text-neutral-900 bg-background-primary>
    <NuxtLayout>
      <div fubex-container py-80px>
        <div flex flex-col items-center text-center gap-24px>
          <h1 text-128px md:text-188px font="700" text-primary-500 dark:text-primary-300>
            {{ error.statusCode }}
          </h1>
          <pre>{{ error.statusMessage }}</pre>

          <div mt-40px>
            <NuxtLink to="/">
              <FButton name="error-back" w-full px-24px>
                Zpět na úvodnní stránku
              </FButton>
            </NuxtLink>
          </div>
        </div>
      </div>
    </NuxtLayout>
  </div>
</template>
